import './App.css';

import { PodContextProvider } from './refactor/PodContext';
import PodPage from './refactor/pages/PodPage';
import { HashRouter } from 'react-router';
import { initMixpanel } from './mixpanel/mixpanel';

const App = () => {

  initMixpanel(window.location.search)

  return (
      <div className="App">
        <PodContextProvider>
          <HashRouter>
          {/*<ErrorBoundary FallbackComponent={ErrorPage}>*/}
          <PodPage />
          {/*</ErrorBoundary>*/}
          </HashRouter>
          </PodContextProvider>
      </div>
  )
}

export default App;
